import { Component, HostListener, OnInit, Inject } from '@angular/core';
import { DatadogService } from '@dn/libs/ui/dn-common';
import { getDatadogConfig } from './app.component.config';
import { AnalyticsService } from './core/service/analytics/analytics.service';
import { UtilityService } from './core/service/untility/utility.service';
import { fadeAnimation } from './pages/animations/route-animate';
import { APP_CONFIG } from './tokens/app-config.token';
import { Environment } from '../environments/environment.interface';

@Component({
    selector: 'dn-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    animations: [fadeAnimation],
    standalone: false,
})
export class AppComponent implements OnInit {
  title = 'datanyze';
  @HostListener('document:click', ['$event'])
  onClick(event) {
    this.utilService.documentClickedTarget.next(event);
  }
  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly utilService: UtilityService,
    private readonly datadogService: DatadogService,
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
  ) {

  }

  ngOnInit(): void {
    this.analyticsService.activateGoogleTagManager();
    this.datadogService.initService(getDatadogConfig(this.appConfig));
  }
}
